module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_a03/main_pc_ff7836723022b8a96f29d4bcec156387.jpg";